"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _Text = require("../Text");
var _TextareaModule = _interopRequireDefault(require("./Textarea.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Textarea_ = (props, ref) => {
  const {
    value,
    onChange,
    onFocus,
    onBlur,
    name,
    disabled,
    placeholder,
    error,
    locked,
    errorText,
    label,
    helperText,
    classNames,
    size = 'medium',
    required,
    textCountLimit,
    ...textareaProps
  } = props;
  const [textCountError, setTextCountError] = React.useState(false);
  React.useEffect(() => {
    if (textCountLimit) {
      if (value && value.length > textCountLimit) {
        setTextCountError(true);
      } else {
        setTextCountError(false);
      }
    }
  }, [value]);
  const controlledTextareaFilled = value !== '';
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_TextareaModule.default.wrapper, {
      [_TextareaModule.default.filled]: controlledTextareaFilled ?? false,
      [_TextareaModule.default.withError]: (error || textCountError) ?? false
    })
  }, Boolean(label) && /*#__PURE__*/React.createElement("div", {
    className: _TextareaModule.default.info
  }, /*#__PURE__*/React.createElement("div", {
    className: _TextareaModule.default.infoContent
  }, /*#__PURE__*/React.createElement(_Text.FormLabelSmall, {
    color: "secondary"
  }, label ?? ''), "\xA0", required && /*#__PURE__*/React.createElement(_Text.FormLabelSmall, {
    color: "danger"
  }, '*')), /*#__PURE__*/React.createElement(_Text.FormLabelSmall, {
    color: error || textCountError ? 'danger' : 'secondary'
  }, !!textCountLimit && (value && value.length || 0) + '/' + textCountLimit)), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_TextareaModule.default.box, {
      [_TextareaModule.default.inputDisabled]: disabled ?? false,
      [_TextareaModule.default.medium]: size === 'medium',
      [_TextareaModule.default.small]: size === 'small',
      [_TextareaModule.default.locked]: locked
    }, classNames?.box)
  }, /*#__PURE__*/React.createElement("textarea", _extends({}, textareaProps, {
    disabled: locked || disabled,
    name: name
    // @ts-ignore - TS2322 - Type '{ current: HTMLTextAreaElement | null; } | ((arg1: HTMLTextAreaElement | null) => unknown)' is not assignable to type 'Ref<HTMLTextAreaElement> | undefined'.
    ,
    ref: ref,
    placeholder: placeholder,
    value: value
    // @ts-ignore - TS2322 - Type '((evt: ChangeEvent<HTMLInputElement>, isEnter?: boolean | undefined) => unknown) | undefined' is not assignable to type 'ChangeEventHandler<HTMLTextAreaElement> | undefined'.
    ,
    onChange: onChange
    // @ts-ignore - TS2322 - Type '((e: ChangeEvent<HTMLInputElement>) => unknown) | undefined' is not assignable to type 'FocusEventHandler<HTMLTextAreaElement> | undefined'.
    ,
    onFocus: onFocus
    // @ts-ignore - TS2322 - Type '((e: ChangeEvent<HTMLInputElement>) => unknown) | undefined' is not assignable to type 'FocusEventHandler<HTMLTextAreaElement> | undefined'.
    ,
    onBlur: onBlur,
    className: classNames?.textarea
  }))), (Boolean(helperText) || error) && /*#__PURE__*/React.createElement("div", {
    className: _TextareaModule.default.info
  }, /*#__PURE__*/React.createElement(_Text.BodySmall, {
    color: error && errorText ? 'danger' : disabled ? 'disabled' : 'secondary'
  }, error && errorText ? errorText : helperText ?? '')));
};

// @ts-ignore - TS2345 - Argument of type '(props: TextareaProps, ref: { current: null | HTMLTextAreaElement; } | ((arg1: null | HTMLTextAreaElement) => unknown)) => React.JSX.Element' is not assignable to parameter of type 'ForwardRefRenderFunction<HTMLTextAreaElement, TextareaProps>'.
const Textarea = exports.Textarea = /*#__PURE__*/React.forwardRef(
//@ts-expect-error
Textarea_);